export const dnld_SMS_CDR = (builder) => ({
    dnld_SMS_CDR: builder.mutation({
        query: ({  search, status, loggedin_user_id, user_type_id, sender_type, startDate, endDate }) => {
            return {
                url: '/downloadSmsCdrDetails',
                method: 'GET',
                params: {  search, status, loggedin_user_id, user_type_id, sender_type, startDate, endDate  },
                headers: {
                    'Content-Type':  'text/csv', 
                },
                responseHandler: (response) => response.blob(),
            };
        },
    }),
});